/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Deep_TitleInputs */

const en_diff_deep_title = /** @type {(inputs: Diff_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrays are matched by position, and that matters`)
};

const ko_diff_deep_title = /** @type {(inputs: Diff_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배열은 위치로 대응되며, 그 점이 중요합니다`)
};

const ja_diff_deep_title = /** @type {(inputs: Diff_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列は位置で対応され、その点が重要です`)
};

/**
* | output |
* | --- |
* | "Arrays are matched by position, and that matters" |
*
* @param {Diff_Deep_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_deep_title = /** @type {((inputs?: Diff_Deep_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Deep_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_deep_title(inputs)
	if (locale === "ko") return ko_diff_deep_title(inputs)
	return ja_diff_deep_title(inputs)
});